import logoXproject from '../../../assets/images/logoXproject2025.png'
import packageJson from '../../../../package.json'
export const Bienvenido = () => {
    const version = packageJson.version


    return (
        <>
            <div className='opacity-30 flex flex-col items-center justify-center w-full h-full'>
                <img src={logoXproject} className=' w-[600px] lg:w-[200px]'></img>
                <span className='text-xl'>V. {version}</span>
            </div>
        </>
    )
}